interface Props {
  name: string;
  href?: string;
  onClick?: (SyntheticEvent: any) => void;
  className?: string;
  tooltip: string;
}
const Anchor = ({ name, href = '#', onClick, className, tooltip }: Props) => (
  <a
    data-tooltip={tooltip}
    className={className || ''}
    href={href}
    onClick={onClick || null}
  >
    {name}
    <style jsx>{`
      .transactions-link::after {
        content: '';
        position: absolute;
        top: 25px;
        margin-left: 2px;
        display: inline-block;
        border: solid #4285f4;
        border-width: 2px 2px 0 0;
        padding: 2px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
      }

      .mobile::after {
        top: 8px !important;
      }
    `}</style>
  </a>
);

export default Anchor;



// WEBPACK FOOTER //
// ./components/ui/Anchor.tsx